import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-upgrade",
  "use": "icon-upgrade-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-upgrade\"><g fill=\"currentColor\"><path d=\"M8 22a1 1 0 110 2H4a4 4 0 01-4-4V4a4 4 0 014-4h16a4 4 0 014 4v16a4 4 0 01-4 4h-4a1 1 0 010-2h4a2 2 0 002-2V4a2 2 0 00-2-2H4a2 2 0 00-2 2v16a2 2 0 002 2h4z\" /><path d=\"M11 8.388l-4.29 4.317a1 1 0 11-1.42-1.41l6.516-6.555 6.553 6.553a1 1 0 01-1.414 1.414L13 8.762V23a1 1 0 01-2 0V8.388z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol